import React, {useState} from "react";
import Popup from "../../../UI/Popup/Popup";
import {sendEmail, updateFilePermission} from "../../../../graph-services/GraphServices";
import {ReferenceCPStatus as status} from "../../ReferenceCPStatus"
import {translation} from "../../../../I18n/i18n";

const Element = (props) => {

    let fileBaseName = props.fileName.replace (".xml", "");
    let [emailBodyText, setEmailBodyText] = useState ("");
    let settings = {
        share: {
            emailSubject: `${ fileBaseName } ${ translation (props.lang, `has been shared with you`) }`,
            title: translation (props.lang, `Your Consultant Profile needs to be completed`),
            successNotification: translation (props.lang, `The Consultant Profile has been shared !`),
            errorNotification: translation (props.lang, `An error has occurred !`),
            popupText: translation (props.lang, `This will share access with the consultant in order to complete the Consultant Profile`),
            nextStatus: status.toBeCompleted.code,
            nextPermission: `write`,
            recipientEmail: props.consultantEmail,
            hasIntroSection: true,
            intro: dynamizeText (translation (props.lang, `Dear colleague,<br><br>We are asking you to <strong>update your Consultant Profile</strong>.<br><br>To this end, we provide you with a secure tool developed by Aprico ($) available for installation from the applications catalogue in Teams.<br><br>Do not hesitate to contact us in case of problems.`), process.env.REACT_APP_NAME),
            commentsTitle: translation (props.lang, `HR Comments`),
            hasCardSection: true,
            hasCardTitle: true,
            cardTitle: translation (props.lang, `Please proceed as soon as possible with this important request!`),
            callToAction: translation (props.lang, `UPDATE MY PROFILE`),
        },
        notify: {
            emailSubject: `${ fileBaseName } ${ translation (props.lang, "has been completed") }`,
            title: `${ fileBaseName } ${ translation (props.lang, "needs to be validated") }`,
            successNotification: translation (props.lang, `The Consultant Profile has been completed !`),
            errorNotification: translation (props.lang, `An error has occurred !`),
            popupText: `This will notify HR members that you have completed filling out your Consultant Profile`,
            nextStatus: status.toBeValidated.code,
            nextPermission: `read`,
            recipientEmail: process.env.REACT_APP_HR_GROUP_EMAIL,
            hasIntroSection: false,
            commentsTitle: translation (props.lang, `Consultant Comments`),
            hasCardSection: true,
            hasCardTitle: false,
            callToAction: translation (props.lang, `OPEN MY PROFILE`),
        },
        validate: {
            emailSubject: `${ fileBaseName } ${ translation (props.lang, "has been validated") }`,
            title: translation (props.lang, `Your Consultant Profile has been validated`),
            successNotification: translation (props.lang, `The Consultant Profile has been validated !`),
            errorNotification: translation (props.lang, `An error has occurred !`),
            popupText: `This will set the Consultant Profile as validated`,
            nextStatus: status.validated.code,
            nextPermission: `read`,
            recipientEmail: props.consultantEmail,
            hasIntroSection: true,
            intro: translation (props.lang, `Dear colleague,<br><br>We thank you for the update and the time you spent filling in this information.<br><br>Your Consultant Profile has been validated by the HR team and will be used in the context of our business activities.<br><br>You can now have access to your Consultant Profile whenever you want via the application (read-only).<br><br>If you have any questions about the application or your Consultant Profile, please contact us via <a href="mailto:consultantprofile@aprico-consult.com">consultantprofile@aprico-consult.com</a><br><br>Sincerely,<br><strong>HR Team</strong>`),
            commentsTitle: translation (props.lang, `HR Comments`),
            hasCardSection: true,
            hasCardTitle: false,
            callToAction: translation (props.lang, `OPEN MY PROFILE`),
        },
        invalidate: {
            emailSubject: dynamizeText (`${ translation (props.lang, "$ changes have not been accepted") }`, fileBaseName),
            title: translation (props.lang, `Your Consultant Profile still needs to be completed`),
            successNotification: translation (props.lang, `The Consultant Profile has been invalidated !`),
            errorNotification: translation (props.lang, `An error has occurred !`),
            popupText: translation (props.lang, `This will invalidate the changes and share the Consultant Profile again to complete it`),
            nextStatus: status.inValidated.code,
            nextPermission: `write`,
            recipientEmail: props.consultantEmail,
            hasIntroSection: true,
            intro: dynamizeText (translation (props.lang, `Dear colleague,<br><br>We are asking you to <strong>update your Consultant Profile</strong>.<br><br>To this end, we provide you with a secure tool developed by Aprico ($) available for installation from the applications catalogue in Teams.<br><br>Do not hesitate to contact us in case of problems.`), process.env.REACT_APP_NAME),
            commentsTitle: translation (props.lang, `HR Comments`),
            hasCardSection: true,
            hasCardTitle: true,
            cardTitle: translation (props.lang, `Please proceed as soon as possible with this important request!`),
            callToAction: translation (props.lang, `UPDATE MY PROFILE`),
        },
    };

    let caseOf = (actionBtnName) => {
        switch (actionBtnName) {
            case "Share":
                return settings.share;
            case "Notify HR":
                return settings.notify;
            case "Force Validation":
                return settings.forceValidation;
            case "Validate":
                return settings.validate;
            case "Invalidate":
                return settings.invalidate;
            default:
                throw new Error ();
        }
    }

    let updateMessageValue = (value) => {
        setEmailBodyText (value)
    }

    let changeFilePermission = async (permission) => {
        return await updateFilePermission (props.token, props.siteId, props.fileId, props.consultantEmail, permission)
    }

    let actionSettings = caseOf (props.actionBtnName);

    let handleLoading = (v) => {
        props.onLoading (v);
    }

    let mail = async () => {
        return await sendEmail (actionSettings.recipientEmail, actionSettings.emailSubject, {
            hasCommentsSection: emailBodyText && emailBodyText !== "" && emailBodyText !== `<p><br></p>`,
            comments: emailBodyText, ...actionSettings,
            cardDescription: translation (props.lang, `Here is the link to your Consultant Profile`),
            endText: translation (props.lang, `Aprico Consultants helps major organizations across a range of sectors deal with disruptive change and legacy IT challenges. Through smart transformation, IT investment is aligned with business strategy, providing adaptable and agile processes that save time, cut costs and maximize revenue. Aprico is based in Brussels and has nearshore development offices.`)
        })
    }

    let onActionHandler = () => {
        props.changeStatus (actionSettings.nextStatus)
            .then (r => {
                if (r.ok) {
                    mail ()
                        .then (r => {
                            if (r === "success") {
                                changeFilePermission (actionSettings.nextPermission)
                                    .then (r => {
                                        if (r) {
                                            handleLoading (false);
                                            props.notify (actionSettings.successNotification, "success");
                                            props.closeDrawer ();
                                        } else {
                                            handleLoading (false);
                                            props.notify (actionSettings.errorNotification, "error");
                                        }
                                        props.reload ()
                                    })
                            } else {
                                handleLoading (false);
                                props.notify (actionSettings.errorNotification, "error");
                            }
                        });
                } else {
                    handleLoading (false);
                    props.notify (actionSettings.errorNotification, "error");
                }
            })
    }

    let onSubmitHandler = async () => {
        handleLoading (true);
        props.hidePopup ();

        if (props.hasNewEmail) {
            let r = await props.saveNewEmail (actionSettings.nextPermission)

            if (r) {
                await onActionHandler ()
            } else {
                handleLoading (false);
                props.notify (actionSettings.errorNotification, "error");
            }
        } else {
            await onActionHandler ()
        }
    }

    let onCloseHandler = () => {
        updateMessageValue (" ");
        props.hidePopup ();
    };


    return (
        <Popup
            lang={ props.lang }
            dict={ props.dict }
            id={ `${ props.actionBtnName }-Popup` }
            show={ props.isOpenPopup }
            onClose={ onCloseHandler }
            anchorEl={ props.popupLauncher }
            title={ `${ props.actionBtnName } ?` }
            subtitle={ fileBaseName }
            body={ actionSettings.popupText }
            hasInput={ true }
            onInputValueChange={ (v) => updateMessageValue (v) }
            inputValue={ emailBodyText }
            submitBtnLabel="Yes"
            onSubmit={ onSubmitHandler }
            cancelBtn={ true }
            cancelBtnLabel="No"
        />
    );
}

export default Element;

let dynamizeText = (staticText, replacer) => staticText.replace (`$`, replacer)